<template>
  <div>
    <div class="dyy print-container" id="dy" ref="htmlDom">
      <div id="programmes" style="width: 100%;display: flex;justify-content: center;padding-bottom: 30px;">
        <div style="width: 1050px;padding: 0;" id="programme">
          <div style="width: 100%;font-weight: bold;font-size: 25px;text-align: center;margin-top: 40px;">
            <span>{{ neweditForm.name }}</span>
            <span style="margin-left: 1em;">高考志愿填报方案</span>
          </div>
          <div style="width: 1050px;margin: auto;margin-top: 30px;">
            <div v-if="tableData.length > 0">
              <div v-for="(items, index) in tableData">
                <div style="height: 70px;">
                  <span style="line-height: 70px;font-size: 19px;font-weight: bold;">
                    <p style="text-align: center;">{{ items[0].programmeName }}</p>
                  </span>
                </div>
                <div class="d1-2" style="height: 60px;text-align: center;">
                  <span style="font-size: 17px;line-height: 60px;">姓名:</span>
                  <span style="font-size: 17px;line-height: 60px;margin-left: 3px;">{{ neweditForm.name }}</span>
                  <span style="font-size: 17px;line-height: 60px;margin-left:30px">科类:</span>
                  <span style="font-size: 17px;line-height: 60px;margin-left: 3px;">
                    <span v-if="neweditForm.major == 1">物理</span>
                    <span v-if="neweditForm.major == 2">历史</span>
                    <span v-if="neweditForm.major == 3">物理</span>
                    <span v-if="neweditForm.major == 4">历史</span>
                  </span>
                  <span style="font-size: 17px;line-height: 60px;margin-left: 3px;">{{ neweditForm.subject1 }}</span>
                  <span style="font-size: 17px;line-height: 60px;margin-left: 3px;">{{ neweditForm.subject2 }}</span>
                  <span style="font-size: 17px;line-height: 60px;margin-left:30px;">批次:</span>
                  <span style="font-size: 17px;line-height: 60px;margin-left: 3px;">{{ items[0].batch }}</span>
                  <span v-if="items[0].batch.indexOf('提前')>=0 || items[0].batch === '本科普通批单设'" style="font-size: 17px;line-height: 60px;margin-left: 30px;">招生类别:</span>
                  <span v-if="items[0].batch.indexOf('提前')>=0 || items[0].batch === '本科普通批单设'" style="font-size: 17px;line-height: 60px;margin-left: 3px;">{{ items[0].recruitType }}</span>
                  <span style="font-size: 17px;line-height: 60px;margin-left:30px;">分数:</span>
                  <span style="font-size: 17px;line-height: 60px;margin-left: 3px;">{{ neweditForm.score }}</span>
                  <span style="font-size: 17px;line-height: 60px;margin-left:30px;">位次:</span>
                  <span style="font-size: 17px;line-height: 60px;margin-left: 3px;">{{ neweditForm.precedence }}</span>
                </div>
                <table border style="width: 100%;" id="tables">
                  <thead>
                    <tr>
                      <th width="70">序列</th>
                      <th width="150">代码</th>
                      <th width="610">院校名称(录取形式)/专业(类)|包含专业</th>
                      <th width="100">招生类别</th>
                      <th width="80">{{items[0].nowYear-2}}投档位次</th>
                      <th width="80">{{items[0].nowYear-1}}投档位次</th>
                      <th width="80">{{items[0].nowYear}}投档位次</th>
                      <th width="80">{{items[0].planYear}}计划</th>
                      <th width="100">学费(元/年)</th>
                    </tr>
                  </thead>
                  <tbody v-for="zhi in items">
                    <tr style="background-color: #d4d4d4;">
                      <td style="text-align: center;font-weight:bolder;">
                        <span v-if="zhi.schemeName">志愿</span>
                        {{ zhi.schemeName }}
                      </td>
                      <td style="text-align: center;font-weight:bolder;">{{ zhi.schoolCode }}-{{ zhi.groupCode }}</td>
                      <td>
                        <span style="margin-left: 10px;font-weight:bolder;">
                          {{ zhi.schoolName }}
                        </span>
                        <span style="font-size: 10px;">
                          ({{ zhi.level }}  {{ zhi.city }})
                        </span>
                        <span style="float: right;margin-right: 10px;font-weight:bolder;" v-show="zhi.schoolName">
                          <span style="margin-left: 30px;"
                            v-if="zhi.batch != '提前批A段' && zhi.batch != '提前批B段' && zhi.batch != '提前批C段' && zhi.batch != '提前批专科' && zhi.batch != '一批特殊' && zhi.batch != '二批特殊'">
                            {{ zhi.majorPlan }}|
                          </span>
                          服从调剂：<span>{{ zhi.schemeChange == 0 ? "是" : "否" }}</span>
                        </span>
                      </td>
                      <td style="text-align: center;font-weight:bolder;">{{ zhi.recruitType }}</td>
                      <td style="text-align: center;font-weight:bolder;">{{ zhi.ranking2019 }}</td>
                      <td style="text-align: center;font-weight:bolder;">{{ zhi.ranking2020 }}</td>
                      <td style="text-align: center;font-weight:bolder;">{{ zhi.ranking2021 }}</td>
                      <td style="text-align: center;font-weight:bolder;">{{ zhi.plan2022 }}</td>
                      <td></td>
                    </tr>
                    <tr v-for="zy in zhi.majorList">
                      <td style="text-align: center;">{{ zy.sort }}</td>
                      <td style="text-align: center;">{{ zy.majorCode }}</td>
                      <td colspan="2">
                        <span style="margin-left: 10px;display: inline-block;margin-right: 10px;">
                          {{ zy.majorName}}
                        </span>
                        <span v-show="zy.level">【{{ zy.level }}】</span>
                      </td>
                      <td style="text-align: center;">{{ zy.minRanking2015 }}</td>
                      <td style="text-align: center;">{{ zy.minRanking2016 }}</td>
                      <td style="text-align: center;">{{ zy.minRanking2017 }}</td>
                      <td style="text-align: center;">{{ zy.plan2018 }}</td>
                      <td style="text-align: center;">{{ zy.majorLimit }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else style="padding: 20px 0;text-align: center;color: #999;">
              <i class="el-icon-warning-outline"></i>
              <span>暂无填报方案</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧悬浮 -->
      <div id="npt">
        <div style="background-color: #5DBE2D;" v-print="'#programme'">
          <i class="icon-el el-icon-printer"></i>
          <span>打印</span>
        </div>
        <div style="background-color: #1B94D2;" @click="getPdf('#programmes')">
          <i class="icon-el el-icon-download"></i>
          <span>下载</span>
        </div>
        <div style="background-color: #415B8A;" @click="goBack()">
          <img class="icon" src="~@/assets/images/design/icon_return.png" alt="icon" />
          <span>返回</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/util/request";
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  props: {
    printIds: {
      default: []
    },
  },
  data() {
    return {
      loading: false,
      neweditForm: null,
      tableData: [],
      stuId: '',
    }
  },
  created() {
    this.init()
  },
  mounted() {
  },
  methods: {
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 基础信息及表格内容获取
    init() {
      const user = JSON.parse(sessionStorage.getItem('user'))
      this.userId = user.userId
      if (user.userType == 3) {
        this.neweditForm = JSON.parse(localStorage.getItem('stu'))
        this.stuId = this.neweditForm.id
        this.neweditForm.examMsg = JSON.parse(this.neweditForm.examMsg)
        this.neweditForm.checkMsg = JSON.parse(this.neweditForm.checkMsg)
        this.getPrintScheme()
      } else if (user.userType == 4) {
        this.neweditForm = JSON.parse(localStorage.getItem('stu'))
        this.getStudentInfo()
      }
    },
    // 获取学生信息
    getStudentInfo() {
      request({
        method: 'get',
        url: 'students/getStu',
        params: {
          Id: this.userId
        }
      }).then(res => {
        this.neweditForm = res.data
        this.stuId = this.neweditForm.id
        this.neweditForm.examMsg = JSON.parse(this.neweditForm.examMsg)
        this.getPrintScheme()
      })
    },
    // 下载pdf
    getPdf(url) {
      let title = ''
      if (url == '#programmes') {
        title = this.neweditForm.name + "方案信息";
        window.open(`${this.$constants.serverUrl}/mendaoVoluntary/stuSchemeV2/getPrintSchemePdf?stuId=` + this.stuId + '&ids=' + this.printIds);
        return;
      } else if (url == '#datas') {
        title = this.neweditForm.name + "高考志愿填报档案表";
      } else if (url == '#newschool') {
        title = this.neweditForm.name + "选科方案";
      } else if (url == '#majors') {
        title = this.neweditForm.name + "专业方向";
      }

      html2Canvas(document.querySelector(url), {
        allowTaint: true,
        taintTest: false,
        logging: false,
        useCORS: true,
        dpi: window.devicePixelRatio * 1.5, //将分辨率提高到特定的DPI 提高四倍
        // dpi:300,
        scale: 1.5 //按比例增加分辨率
      }).then(canvas => {
        var pdf = new JsPDF('p', 'mm', 'a4');    //A4纸，纵向

        var ctx = canvas.getContext('2d'),
          a4w = 260, a4h = 280,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
          imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
          renderedHeight = 0;
        ctx.mozImageSmoothingEnabled = false;
        ctx.webkitImageSmoothingEnabled = false;
        ctx.msImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
        while (renderedHeight < canvas.height) {
          var page = document.createElement("canvas");
          page.width = canvas.width;
          page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页

          //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
          pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', -25, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距

          renderedHeight += imgHeight;
          if (renderedHeight < canvas.height) {
            pdf.addPage();//如果后面还有内容，添加一个空页
          }
        }
        //保存文件
        pdf.save(title + '.pdf')

      })
    },
    // 专家版获取学生所有高考填报方案
    getPrintScheme() {
      request({
        method: 'POST',
        url: 'stuSchemeV2/getPrintScheme',
        params: {
          stuId: this.stuId,
          ids: this.printIds
        }
      }).then(res => {
        res.data.flat().map(item => {
          item.majorList = item.majorList ? JSON.parse(item.majorList) : []
          if (['', null, undefined].includes(item.majorList)) {
            item.majorList = [{ 'majorName': '', 'majorCode': '', "sort": '' }]
          }
          if (['提前批A段', '提前批B段', '提前批C段', '提前批专科', '一批特殊', '二批特殊'].includes(item.batch)) {
            item.majorPlan = null
          }
          item.majorList.sort((a, b) => {
            return a['sort'].localeCompare(b['sort'])
          })

          let sortList = []
          let bList = []
          item.majorList.map(major => {
            major.sort == '备选' ? bList.push(major) : sortList.push(major)
          })
          sortList.push(...bList)
          item.majorList = sortList
        })
        this.tableData = res.data
      })
    },
  },

}
</script>
<style lang="stylus" rel="stylesheet/stylus">

body, html {
  height: inherit
}

.jc {
  font-weight: bold;
}

.jl {
  font-size: 18px;
  font-weight: bold;
  margin-right: 2%;
  display: inline-block;
  width 10em
  margin-top 10px
}

.tp {
  width 100%
  margin auto
  line-height 30px
}

.dyy #xx .el-checkbox-button__inner {
  width: 40px;
  height: 25px;
}

#dy #npt {
  top: 20%;
  right 5%;
  z-index: 99999;
  position: fixed;
}

#dy #npt1 {
  top: 20%;
  z-index: 99999;
  position: fixed;
  right 5%;
}

#npt1 button {
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 15px;
  font-weight: initial;
  padding: 0;
  text-align: center;
}

#npt1 button span {
  display: inline-block;
  margin: auto;
}

#dy {
  font-size 15px
  -webkit-print-color-adjust: exact
}

@media print {
  #baseData, #programme, #newschools, #major {

    * {
      -webkit-print-color-adjust: exact;
      -moz-print-color-adjust: exact;
      -ms-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    border: solid 1px #fff;
  }

}

#programmes table tr {

  page-break-inside: avoid;

}

#newschool table tr {

  page-break-inside: avoid;

}

//#dy .el-table {
//  border-color black
//  border-bottom 1px solid #000000
//  border-right 1px solid #000000
//}

#tables {
  width: 400px; //表格的宽度
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  border-spacing: 0; /*把单元格间隙设置为0*/
  // font-family: "宋体"
}

#tables th, td {
  height: 40px;
  font-weight: 400;
}

</style>

<style lang="stylus" scoped>
pageWidth = 1400px
$color-theme = #f96630
$color-table-border = #999

.print-container
  width: pageWidth;
  margin: 0 auto;
  font-size: 14px;

  div
    box-sizing: border-box;

  .m-l-20
    margin-left 20px

  .b-r-l
    border-left: 1px solid $color-table-border;
  .b-r-r
    border-right: 1px solid $color-table-border;
  .p-0-10
    padding: 0 10px;
</style>

<style scoped media="print">
/*指定打印的分页*/
/*
/deep/ section {
  page-break-after: always;
}
*/

/*避免出现空白尾页*/
html,
body,
#app {
  height: 98% !important;
  margin: 0px;
  padding: 0px;
}
</style>
<style>
.print-container {
  width: 1400px;
  margin: 0 auto;
  font-size: 14px;
}

.print-container div {
  box-sizing: border-box;
}

.m-l-20 {
  margin-left: 20px
}

.m-t-20 {
  margin-top: 20px
}

.b-r-l {
  border-left: 1px solid #999;
}

.b-r-r {
  border-right: 1px solid #999;
}

.p-0-10 {
  padding: 0 10px;
}

.txt-l {
  text-align: left !important;
}

.base-data {
  width: 1050px;
  margin: auto;
  padding: 0;
}

.base-data .base-title {
  width: 100%;
  margin-top: 50px;
  font-size: 25px;
  color: #333;
  font-weight: 600;
  text-align: center
}

.base-data .base-table {
  margin: 50px auto;
  border: 1px solid #999;
}

.base-data .base-tr,
.base-tr-other {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid #999;
}

.base-data .base-tr:last-child {
  border-bottom: none
}

.base-data .base-tr>div {
  flex: 1;
  min-height: 33px;
  line-height: 33px;
  padding: 0 10px;
  text-align: center;
  border-right: 1px solid #999
}

.base-data .base-tr>div:last-child {
  border-right: none
}

.base-data .base-tr-other>div {
  width: 10%;
  min-height: 33px;
  line-height: 33px;
  padding: 0 10px;
  text-align: center;
  border-right: 1px solid #999
}

.base-data .base-tr-other>div:nth-child(2n-1) {
  font-weight: 600;
}

.base-data .base-tr-other>div:last-child {
  border-right: none;
}

.base-data .title-th {
  font-size: 16px;
  font-weight: 600;
}

.base-data .remark-box {
  min-height: 60px !important;
  text-align: left !important;
}

.base-data .base-tr-other .w-10 {
  flex: 1;
  padding: 0 !important;
  min-height: 33px;
  line-height: 33px;
}

.base-data .base-tr-other .w-20 {
  flex: 2;
  padding: 0 !important;
  min-height: 33px;
  line-height: 33px;
}

.base-data .base-tr .flex-4 {
  flex: 4;
  padding: 0 !important;
  min-height: 33px;
  line-height: 33px;
}

.base-data .base-tr .flex-5 {
  flex: 5;
  padding: 0 !important;
  min-height: 33px;
  line-height: 33px;
}

.base-data .base-tr .flex-8 {
  flex: 8;
  padding: 0 !important;
  min-height: 33px;
  line-height: 33px;
  display: flex;
  align-items: center;
}

.base-data .base-tr .flex-8>div {
  flex: 1;
  min-height: 33px;
  text-align: center;
  border-right: 1px solid #999
}

.base-data .base-tr .flex-8>div:last-child {
  border-right: none
}

.base-data .base-tr .intention-apply-tr {
  display: flex;
  align-items: center;
  padding: 0 !important;
}

.base-data .apply-left {
  flex: 1;
}

.base-data .apply-right {
  flex: 9;
}

.base-data .apply-right .el-checkbox {
  width: 80px;
}

.base-data .checked-section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.base-data .checked-section .checked-box {
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.base-data .checked-section .checked-box-active {
  color: #f96630;
}

.base-data .checked-section .checked-box .inner-box {
  position: relative;
  margin-right: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
}

.base-data .checked-section .checked-box .inner-box-active {
  position: relative;
  margin-right: 10px;
  border: 1px solid #f96630;
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
}

.base-data .child-box {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #999;
}

.base-data .child-box:last-child {
  border-bottom: none;
}

.base-data .child-left {
  flex: 1.5;
  padding: 0 10px;
  border-left: 1px solid #999;
  border-right: 1px solid #999;
}

.base-data .child-right {
  flex: 8.5;
  padding: 0 10px;
}

.base-data .score-tr div {
  flex: 0.7;
}</style>
